export const validHex = color => /^#[0-9a-f]{6}$/i.test(color);
export function swatchInk(hex) {
  const channels = [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16) / 255)
    .map(channel => channel <= .04045 ? channel / 12.92 : ((channel + .055) / 1.055) ** 2.4);
  return channels[0] * .2126 + channels[1] * .7152 + channels[2] * .0722 > .179 ? '#000000' : '#FAF9F6';
}
export function hsvToHex(h, s, v) {
  const chroma = s * v;
  const x = chroma * (1 - Math.abs((h / 60) % 2 - 1));
  const part = [[chroma, x, 0], [x, chroma, 0], [0, chroma, x], [0, x, chroma], [x, 0, chroma], [chroma, 0, x]][Math.min(5, Math.floor(h / 60))];
  return '#' + part.map(n => Math.round((n + v - chroma) * 255).toString(16).padStart(2, '0')).join('').toUpperCase();
}
export function hexToHsv(hex) {
  const [r, g, b] = [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16) / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), delta = max - min;
  const h = delta === 0 ? 0 : max === r ? 60 * (((g - b) / delta + 6) % 6)
    : max === g ? 60 * ((b - r) / delta + 2) : 60 * ((r - g) / delta + 4);
  return [h, max === 0 ? 0 : delta / max, max];
}
